import Header from './components/Header';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <RankingSection />
        <CarouselSection />
        <TopicsSection />
        <CardsSection />
        <UpdatesSection />
        <AppSection />
        <FaqSection />
        <AboutSection />
        <FeaturesSection />
        <CommentsSection />
        <ContactSection />
        <IndexSection />
        <MediaSection />
      </main>
      <Footer />
    </>
  );
}